<template>
  <div>
    <div class="form-horizontal col-xs-10">
      <div class="form-group">
        <label class="control-label col-sm-4">Button Text:</label>
        <div class="col-sm-8">
          <input
            name="button_text"
            type="text"
            class="form-control"
            placeholder="eg: Yes I love dogs!"
            v-model="buttonText">
          <div v-if="!validation.button_text.required" class="help-block">Text is required</div>
          <help-block field="button_text"/>
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-4">Assign Tags:</label>
        <tags class="col-sm-8" v-model="tags" creationType="theme" :allow-create="false"/>
      </div>
    </div>
    <a v-if="extraField" class="btn btn-circle btn-danger col-xs-2" v-on:click="removeActionButtonByIndex">
      <i class="fa fa-minus"/>
    </a>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Tags from 'components/misc/Tags'
import { helpers } from 'mixins/profile'
import { stateMapper } from 'mixins/notifications'

export default {
  mixins: [helpers, stateMapper],

  components: {
    Tags
  },

  methods: {
    ...mapActions('notification', ['setNotificationDataProperty', 'setTagDataProperty', 'removeActionButton']),

    removeActionButtonByIndex () {
      this.removeActionButton(this.index)
    }
  },

  computed: {
    ...mapState('notification', ['data']),

    buttonText: {
      get () {
        return this.data.settings.button_items[this.index].button_text
      },

      set (value) {
        this.setNotificationDataProperty(
          { property: `settings.button_items.${this.index}.button_text`, value })
      }
    },

    tags: {
      get () {
        return this.data.settings.button_items[this.index].tags
      },

      set (tags) {
        this.setTagDataProperty(
          { index: this.index, value: tags })
      }
    }
  },

  props: ['extraField', 'index', 'validation']
}
</script>
